var NodesTableHeaderLabels = {
  health: "HEALTH",
  cpus: "CPU",
  disk: "DISK",
  hostname: "HOSTNAME",
  mem: "MEM",
  TASK_RUNNING: "TOTAL TASKS"
};

module.exports = NodesTableHeaderLabels;



// WEBPACK FOOTER //
// ./src/js/constants/NodesTableHeaderLabels.js